import { render, staticRenderFns } from "./PokemonModal.vue?vue&type=template&id=0c6f47ba&scoped=true&"
import script from "./PokemonModal.vue?vue&type=script&lang=js&"
export * from "./PokemonModal.vue?vue&type=script&lang=js&"
import style0 from "./PokemonModal.vue?vue&type=style&index=0&id=0c6f47ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f47ba",
  null
  
)

export default component.exports